// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WfNJ","rootNoMargin":"styles_rootNoMargin__2jC3N"};